// First-party conversion event tracking — fires GA (if present) + our own
// /api/track/event beacon so the admin funnel works without Google Analytics.
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function trackEvent(event, label = '') {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', event, {
        event_category: 'engagement',
        ...(label ? { event_label: label } : {}),
      });
    }
    const payload = JSON.stringify({ event, label, path: window.location.pathname });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API}/track/event`, new Blob([payload], { type: 'application/json' }));
    } else {
      fetch(`${API}/track/event`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
        keepalive: true,
      });
    }
  } catch {
    /* analytics must never break UX */
  }
}
